const clean = (val) => (val === "-" || val === undefined ? "" : val);

const parseNumeric = (value) => {
    if (value === 0) return 0;
    if (!value || value === "-") return 0;

    return parseFloat(String(value).replace(/,/g, "")) || 0;
};

const parseBool = (value) => {
    if (!value || value === "-") return "";
    return value === "Yes" ? true : value === "No" ? false : "";
};

const parsePositiveInt = (value) => {
    if (value === 0) return 0;
    if (!value || value === "-") return 0;

    const parsed = parseInt(String(value).replace(/,/g, ""), 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

const parseCoordinate = () => "";

const parseUniqueTIN = (value) => {
    if (!value || value === "-" || value === "N/A") return "";
    return value;
};

const parseFile = () => "";

const getMeetingTypeMapping = (value) => {
    const mappings = {
        "General Assembly": "GA",
        "Management Meeting": "Management Meetings",
        "Public Relations and Complaints Committee(PRCC)": "PRCC",
    };

    return mappings[value] || value || "";
};

const getSignerMapping = (value) => {
    const mappings = {
        "Presiding Member": "PM",
        Convener: "C",
    };

    return mappings[value] || value || "";
};

const getAssemblyTypeMapping = (value) => {
    const mappings = {
        "Extra Ordinary Meeting": "Special Meeting",
        "Emergency Meeting": "Special Meeting",
    };

    return mappings[value] || value || "";
};

const getProgramTypeMapping = (value) => {
    const mappings = {
        "Economic Empowerment": "Capacity Building",
        "Health Support": "Capacity Building",
        "Education Support": "Capacity Building",
        "Social Support": "Capacity Building",
        "Vocational Training": "Vocation",
        "Skills Development": "Vocation",
    };

    return mappings[value] || "Capacity Building";
};

export function generateProjectId() {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const randomLetters = Array.from({ length: 3 }, () => letters[Math.floor(Math.random() * letters.length)]).join(
        "",
    );
    const randomNumbers = Math.floor(100000 + Math.random() * 900000);

    return `${randomLetters}${randomNumbers}`;
}

export const BULKLOAD_TIN_ATTRIBUTE_ID = "f0aBWJl90eO";

const BULKLOAD_PLACEHOLDER_TIN_VALUES = new Set([
    "tin-102345678",
    "tin-000000000",
    "0000000000",
    "n/a",
    "na",
    "sample",
    "example",
]);

export function isBulkloadPlaceholderTin(value) {
    const normalized = String(value || "")
        .trim()
        .toLowerCase();

    if (!normalized || normalized === "-") {
        return true;
    }

    return BULKLOAD_PLACEHOLDER_TIN_VALUES.has(normalized);
}

export function generateBulkloadTin() {
    const randomNumbers = Math.floor(100000000 + Math.random() * 900000000);
    return `TIN-${randomNumbers}`;
}

export const getGeneralDistrictPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "nVGQlVwOvld", value: row[4] || "" },
                { attribute: "snUEn55Te11", value: row[5] || "" },
                { attribute: "SKeHl5XTZVG", value: row[6] || "" },
                { attribute: "BZbNSkBY5w5", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "2025-01-01",
                    occurredAt: row[3] || "2025-01-01",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "nVGQlVwOvld", value: row[4] || "" },
                        { attribute: "snUEn55Te11", value: row[5] || "" },
                        { attribute: "SKeHl5XTZVG", value: row[6] || "" },
                        { attribute: "BZbNSkBY5w5", value: row[7] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getBillingPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "QUuxyqTen7u", value: row[4] === "-" ? "" : row[4] },
                { attribute: "YfoGKu8N6An", value: row[6] === "-" ? "" : row[6] },
                { attribute: "TBJZqGzKrLx", value: row[9] === "" ? "" : row[9] === "Yes" ? true : false },
                { attribute: "zud2JY8pPTV", value: row[10] === "-" ? "" : row[10] === "Yes" ? true : false },
                { attribute: "hQVox0xawJI", value: row[12] === "-" ? 0 : row[12] },
                { attribute: "spZ8K927Xvd", value: row[5] === "-" ? "" : row[5] },
                { attribute: "LQLke1N578q", value: row[7] === "-" ? "" : row[7] },
                { attribute: "Joaipq2dkMB", value: row[11] === "-" ? "" : row[11] },
                { attribute: "FuOpGyKgvyG", value: row[13] === "-" ? "" : row[13] },
                { attribute: "x4qBAYjalCD", value: row[14] === "-" ? "" : row[14] },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "",
                    occurredAt: row[3] || "",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "QUuxyqTen7u", value: row[4] === "-" ? "" : row[4] },
                        { attribute: "YfoGKu8N6An", value: row[6] === "-" ? "" : row[6] },
                        { attribute: "TBJZqGzKrLx", value: row[9] === "-" ? "" : row[9] === "Yes" ? true : false },
                        { attribute: "zud2JY8pPTV", value: row[10] === "-" ? "" : row[10] === "Yes" ? true : false },
                        { attribute: "hQVox0xawJI", value: row[12] === "-" ? 0 : row[12] },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getBudgetPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Ik7fouv4KOA", value: clean(row[4]) },
                { attribute: "DVNScIHo9ik", value: clean(row[5]) },
                { attribute: "t9GmH5N6fuW", value: row[6] === "-" ? 0 : row[6] },
                { attribute: "w0WC2RVKn5L", value: clean(row[7]) },
                { attribute: "fGfO0hrRRgq", value: clean(row[8]) },
                { attribute: "k921oNWPSd4", value: clean(row[9]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "",
                    occurredAt: row[3] || "",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "Ik7fouv4KOA", value: clean(row[4]) },
                        { attribute: "DVNScIHo9ik", value: clean(row[5]) },
                        { attribute: "t9GmH5N6fuW", value: row[6] === "-" ? 0 : row[6] },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getAAPBaselineAndTargetPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Ik7fouv4KOA", value: clean(row[5]) },
                { attribute: "fGfO0hrRRgq", value: clean(row[6]) },
                { attribute: "venV3bANzNv", value: row[7] === "-" ? 0 : row[7] },
                { attribute: "q5eRJ48BKIR", value: row[8] === "-" ? 0 : row[8] },
                { attribute: "BqDSaAXE5Wy", value: row[9] === "-" ? 0 : row[9] },
                { attribute: "IyL1NC967ul", value: row[10] === "-" ? 0 : row[10] },
                { attribute: "T7cdjc1ljvw", value: row[11] === "-" ? 0 : row[11] },
                { attribute: "Q3x1ejPH6by", value: row[12] === "-" ? 0 : row[12] },
                { attribute: "DualVyRoqaS", value: row[13] === "-" ? 0 : row[13] },
                { attribute: "YaUpC7Sm9Yh", value: row[14] === "-" ? 0 : row[14] },
                { attribute: "t9UOacq47jG", value: row[15] === "-" ? 0 : row[15] },
                { attribute: "KtBwVvQDKlw", value: row[16] === "-" ? 0 : row[16] },
                { attribute: "vrbrHPCFEd4", value: row[17] === "-" ? 0 : row[17] },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "",
                    occurredAt: row[3] || "",
                    status: "ACTIVE",
                    attributes: [{ attribute: "Ik7fouv4KOA", value: row[5] === "-" ? "" : row[5] }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getAAPPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const attributes = [
            { attribute: "pWkYqcKukAY", value: row[4] === "-" ? "" : row[4] },
            { attribute: "IHP9xBgvYu7", value: row[5] === "-" ? "" : row[5] },
            { attribute: "VjFxjvQk0cO", value: row[6] === "-" ? "" : row[6] },
            { attribute: "Ni5mF1bxTcq", value: row[8] === "-" ? "" : row[8] },
            { attribute: "vYOjuRKymY8", value: row[14] === "-" ? "" : row[14] },
            { attribute: "JgjD9cTUbhm", value: row[19] === "-" ? "" : row[19] },
            { attribute: "Go8eelOBPsP", value: row[22] === "-" ? "" : row[22] },
            { attribute: "IZZ2dtfaCC1", value: row[9] === "-" ? "" : row[9] },
            { attribute: "XlP38Ti4IDm", value: row[16] === "-" ? "" : row[16] },
            { attribute: "mdO1ngv0Qt0", value: row[18] === "-" ? 0 : row[18] },
            { attribute: "czWTjDKqOBH", value: row[23] === "-" ? "" : row[23] },
            { attribute: "ny0RvLrYFx3", value: row[7] === "-" ? "" : row[7] },
            { attribute: "k921oNWPSd4", value: row[10] === "-" ? "" : row[10] },
            { attribute: "gSalp5yrAWB", value: row[11] === "-" ? "" : row[11] },
            { attribute: "T7LiYCQ3LAm", value: row[20] === "-" ? "" : row[20] },
            { attribute: "x4qBAYjalCD", value: row[21] === "-" ? "" : row[21] },
        ];

        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes,
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "",
                    occurredAt: row[3] || "",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "pWkYqcKukAY", value: row[4] === "-" ? "" : row[4] },
                        { attribute: "IHP9xBgvYu7", value: row[5] === "-" ? "" : row[5] },
                        { attribute: "VjFxjvQk0cO", value: row[6] === "-" ? "" : row[6] },
                        { attribute: "Ni5mF1bxTcq", value: row[8] === "-" ? "" : row[8] },
                        { attribute: "vYOjuRKymY8", value: row[14] === "-" ? "" : row[14] },
                        { attribute: "JgjD9cTUbhm", value: row[19] === "-" ? "" : row[19] },
                        { attribute: "Go8eelOBPsP", value: row[22] === "-" ? "" : row[22] },
                        { attribute: "IZZ2dtfaCC1", value: row[9] === "-" ? "" : row[9] },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getOperationalHealthFacilityPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "pF64ANEoPYx", value: row[6] || "" },
                { attribute: "KeSsfvs1awo", value: row[7] || "" },
                { attribute: "vIkEALDVio6", value: row[8] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "Xpj7aFWa3ii", value: row[9] || "" },
                { attribute: "SKeHl5XTZVG", value: row[10] || "" },
                { attribute: "vUVEUS3VXbF", value: row[11] || "" },
                { attribute: "YqP6CROSeSq", value: row[13] || "" },
                { attribute: "HgemfhhsXBc", value: row[14] || "" },
                { attribute: "yqvSryblNL4", value: row[15] || "" },
                { attribute: "wSuCvQcwby6", value: row[16] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "2025-01-01",
                    occurredAt: row[3] || "2025-01-01",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[5] || "" },
                        { attribute: "pF64ANEoPYx", value: row[6] || "" },
                        { attribute: "KeSsfvs1awo", value: row[7] || "" },
                        { attribute: "vIkEALDVio6", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSportFacilityPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "d4vGACWAj7R", value: row[4] || "" },
                { attribute: "NU2g62mWHJQ", value: row[5] || "" },
                { attribute: "yqvSryblNL4", value: row[6] || "" },
                { attribute: "wSuCvQcwby6", value: row[7] || "" },
                { attribute: "jBaDMK6rqCA", value: row[9] || "" },
                { attribute: "pF64ANEoPYx", value: row[8] || "" },
                { attribute: "fGfO0hrRRgq", value: row[10] || "" },
                { attribute: "EjkjhZFlslh", value: row[13] || "" },
                { attribute: "EzZnJRWxDdN", value: row[14] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "2025-01-01",
                    occurredAt: row[3] || "2025-01-01",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "d4vGACWAj7R", value: row[4] || "" },
                        { attribute: "NU2g62mWHJQ", value: row[5] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getServiceProvidersPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Hq8it9qapWz", value: row[4] || "" },
                { attribute: "ttyKWvSBAZH", value: row[6] || "" },
                { attribute: "XDjgAYmON2o", value: row[7] || "" },
                { attribute: "tb0nGRwpQEw", value: row[12] || "" },
                { attribute: "gkqU35LKO4t", value: row[13] || "" },
                { attribute: "YqP6CROSeSq", value: row[8] || "" },
                { attribute: "pF64ANEoPYx", value: row[9] || "" },
                { attribute: "sGe7MGw4BVN", value: row[10] || "" },
                { attribute: "SKeHl5XTZVG", value: row[11] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "2025-01-01",
                    occurredAt: row[3] || "2025-01-01",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "Hq8it9qapWz", value: row[4] || "" },
                        { attribute: "ttyKWvSBAZH", value: row[6] || "" },
                        { attribute: "XDjgAYmON2o", value: row[7] || "" },
                        { attribute: "tb0nGRwpQEw", value: row[12] || "" },
                        { attribute: "gkqU35LKO4t", value: row[13] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSchoolProfilePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const schoolId = generateProjectId();
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "UJBblniqPOI", value: row[10] || "" },
                { attribute: "RYU3GpNzokp", value: row[6] || "" },
                { attribute: "IztkGQj5EqM", value: schoolId },
                { attribute: "aNfKUv5kVo7", value: row[5] || "" },
                { attribute: "PX7m8i2KVgT", value: row[7] === "-" ? "" : row[7] === "Yes" ? true : false },
                {
                    attribute: "anVTuGti6SK",
                    value: row[8] === "Technical-Vocational (TVET)" ? "TVET" : row[8] || "",
                },
                { attribute: "kThAAJFKIcE", value: row[9] || "" },
                { attribute: "AlVMRjjWuVo", value: row[11] || "" },
                { attribute: "YqP6CROSeSq", value: row[12] || "" },
                {
                    attribute: "cPGCeyMceZl",
                    value: row[13] && row[13] !== "-" && row[13].includes(",") ? `[${row[13]}]` : "",
                },
                { attribute: "HkovKF0eqVg", value: row[14] === "-" ? "" : row[14] === "Yes" ? true : false },
                { attribute: "kz1eZdE9hm3", value: row[15] === "-" ? "" : row[15] === "Yes" ? true : false },
                { attribute: "kNHdPyj6ed3", value: row[16] === "-" ? "" : row[16] === "Yes" ? true : false },
                { attribute: "ZljvuDqsPJJ", value: row[17] === "-" ? "" : row[17] === "Yes" ? true : false },
                { attribute: "qORPfeTsPeX", value: row[18] === "-" ? "" : row[18] === "Yes" ? true : false },
                { attribute: "x0oK399l4RA", value: row[19] === "-" ? "" : row[19] === "Yes" ? true : false },
                { attribute: "tsn8ekA92aR", value: row[20] === "-" ? "" : row[20] === "Yes" ? true : false },
                { attribute: "wO2BqNRuILL", value: "" },
                { attribute: "YBC49GnEfdi", value: row[23] === "-" ? "" : row[23] === "Yes" ? true : false },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "UJBblniqPOI", value: row[10] || "" },
                        { attribute: "RYU3GpNzokp", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getMeetingsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "eOsejnvfYiV", value: row[4] || "" },
                { attribute: "Mm3f9fbAT8r", value: row[5] || "" },
                { attribute: "rSKzHSBlOyB", value: getSignerMapping(row[7]) },
                { attribute: "Ub0V9Z06aBc", value: row[8] || "" },
                { attribute: "kghpIZgHFsT", value: getMeetingTypeMapping(row[10]) },
                { attribute: "b7uAJaX9obN", value: row[15] || "" },
                { attribute: "HmdJqjjAZZ4", value: row[17] || "" },
                { attribute: "Br9IEOZyKPW", value: row[21] || "" },
                { attribute: "U2RjiIApoYu", value: row[24] || "" },
                { attribute: "iHz18pXkmMd", value: row[25] || "" },
                { attribute: "AiPyh2A2DZ8", value: row[6] || "" },
                { attribute: "unVPW9dCS5B", value: row[9] || "" },
                { attribute: "j0kNoCtC8pj", value: getAssemblyTypeMapping(row[11]) },
                { attribute: "hfCSE8B2L9p", value: row[12] || "" },
                { attribute: "sI8Kj3pfa6k", value: row[13] || "" },
                { attribute: "f1V1vDibPCS", value: row[14] || "" },
                { attribute: "mH8uydlfv03", value: row[16] || "" },
                { attribute: "uRdPt6OIxvU", value: row[22] || "" },
                { attribute: "DGDc7z1ESlb", value: row[23] || "" },
                {
                    attribute: "SdtJSE3jJkV",
                    value: row[26] && row[26] !== "-" && !Number.isNaN(Number(row[26])) ? parseInt(row[26], 10) : 0,
                },
                { attribute: "RFSUywjaDRi", value: row[27] || "" },
                { attribute: "Fup3ibG5EJc", value: row[29] === "-" ? "" : row[29] === "Yes" ? true : false },
                { attribute: "xh6NIEHa8xg", value: row[30] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "eOsejnvfYiV", value: row[4] || "" },
                        { attribute: "Mm3f9fbAT8r", value: row[5] || "" },
                        { attribute: "rSKzHSBlOyB", value: getSignerMapping(row[7]) },
                        { attribute: "Ub0V9Z06aBc", value: row[8] || "" },
                        { attribute: "kghpIZgHFsT", value: getMeetingTypeMapping(row[10]) },
                        { attribute: "b7uAJaX9obN", value: row[15] || "" },
                        { attribute: "HmdJqjjAZZ4", value: row[17] || "" },
                        { attribute: "Br9IEOZyKPW", value: row[21] || "" },
                        { attribute: "U2RjiIApoYu", value: row[24] || "" },
                        { attribute: "iHz18pXkmMd", value: row[25] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getPeopleWithDisabilityPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "yPvU4sPN9hh", value: row[4] || "" },
                { attribute: "PtqWutejid0", value: row[5] || "" },
                { attribute: "j3CyzRTfdAk", value: row[6] || "" },
                { attribute: "NA5Bek1ME81", value: row[7] || "" },
                { attribute: "yUDWmWXB08P", value: row[9] || "" },
                { attribute: "sGe7MGw4BVN", value: row[10] || "" },
                { attribute: "IQv3CJDmDna", value: row[11] || "" },
                { attribute: "XDjgAYmON2o", value: row[12] || "" },
                { attribute: "YqP6CROSeSq", value: row[13] || "" },
                { attribute: "SKeHl5XTZVG", value: row[14] || "" },
                { attribute: "Ax9xIaMCs52", value: "" },
                { attribute: "dxbGTrab2xY", value: row[16] || "" },
                { attribute: "eOMv6uYjj9q", value: row[17] || "" },
                { attribute: "T1YQ9ekJBno", value: row[18] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "yPvU4sPN9hh", value: row[4] || "" },
                        { attribute: "PtqWutejid0", value: row[5] || "" },
                        { attribute: "j3CyzRTfdAk", value: row[6] || "" },
                        { attribute: "NA5Bek1ME81", value: row[7] || "" },
                        { attribute: "yUDWmWXB08P", value: row[9] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getBoundaryDisputePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "mM7z6LuxndL", value: row[4] === "-" ? "" : row[4] === "Yes" ? true : false },
                { attribute: "pWkYqcKukAY", value: row[5] || "" },
                { attribute: "HD4q4W3QGco", value: row[6] || "" },
                { attribute: "ocZLeifIbuv", value: row[7] || "" },
                { attribute: "Y30tp8GBeLJ", value: row[8] || "" },
                { attribute: "PPjSFYtywHl", value: row[9] || "" },
                { attribute: "wkXwSdqiPzv", value: row[10] || "" },
                { attribute: "MJCxNfLfrIy", value: row[11] || "" },
                { attribute: "vNtKem2HjAA", value: row[12] || "" },
                { attribute: "x4qBAYjalCD", value: row[13] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "mM7z6LuxndL", value: row[4] === "-" ? "" : row[4] === "Yes" ? true : false }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getComputerizedBillingSystemPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[4] || "" },
                { attribute: "biAXx5doufe", value: row[6] || "" },
                { attribute: "J2GkQ7g6IFk", value: row[8] || "" },
                { attribute: "RP06q4eZ8Sp", value: row[9] || "" },
                { attribute: "MZWUSf9PCHv", value: row[5] ? Math.floor(parseFloat(row[5]) || 0) : 0 },
                { attribute: "YvIn2QEep25", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[4] || "" },
                        { attribute: "biAXx5doufe", value: row[6] || "" },
                        { attribute: "J2GkQ7g6IFk", value: row[8] || "" },
                        { attribute: "RP06q4eZ8Sp", value: row[9] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getCapacityBuildingNeedsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "VjFxjvQk0cO", value: row[4] || "" },
                { attribute: "Ni5mF1bxTcq", value: row[5] || "" },
                { attribute: "nyeFHN5Z9oJ", value: row[6] || "" },
                { attribute: "vYOjuRKymY8", value: row[8] || "" },
                { attribute: "wcnA9Wodtf2", value: row[11] || "" },
                { attribute: "juVzRNadmPI", value: row[7] || "" },
                { attribute: "fGpjwVJPSUZ", value: row[9] || "" },
                { attribute: "fGfO0hrRRgq", value: row[10] || "" },
                { attribute: "mdO1ngv0Qt0", value: row[12] || "" },
                { attribute: "r7PY1VqUaTr", value: row[13] || "" },
                { attribute: "JgjD9cTUbhm", value: row[14] || "" },
                { attribute: "T7LiYCQ3LAm", value: row[15] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "VjFxjvQk0cO", value: row[4] || "" },
                        { attribute: "Ni5mF1bxTcq", value: row[5] || "" },
                        { attribute: "nyeFHN5Z9oJ", value: row[6] || "" },
                        { attribute: "vYOjuRKymY8", value: row[8] || "" },
                        { attribute: "wcnA9Wodtf2", value: row[11] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDisasterPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "RMSqAr6nFf1", value: row[5] || "" },
                { attribute: "UJBblniqPOI", value: row[6] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "x4qBAYjalCD", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "RMSqAr6nFf1", value: row[5] || "" },
                        { attribute: "UJBblniqPOI", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDecisionsAndComplaintsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        let meetingType = row[4] || "";
        if (meetingType === "General Assembly") meetingType = "GA";
        if (meetingType === "Management Meeting") meetingType = "Management Meetings";
        if (meetingType === "Public Relations and Complaints Committee(PRCC)") meetingType = "PRCC";

        let type = row[5] || "";
        if (type === "Complaint") type = "Complain";

        let serviceType = row[6] || "";
        if (serviceType === "Recreational  services") serviceType = "Recreational  services and Security";

        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "xYKvhN8Oxh8", value: meetingType },
                { attribute: "JRxGCfymyCQ", value: type },
                { attribute: "dKf1SQYMnnb", value: row[8] || "" },
                { attribute: "CVOeyCI3cvs", value: row[9] || "" },
                { attribute: "jhd0GBgu38n", value: serviceType },
                { attribute: "f1V1vDibPCS", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "xYKvhN8Oxh8", value: meetingType },
                        { attribute: "JRxGCfymyCQ", value: type },
                        { attribute: "dKf1SQYMnnb", value: row[8] || "" },
                        { attribute: "CVOeyCI3cvs", value: row[9] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getConsultingAndContractorsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Cq3sRyzWsDo", value: row[4] || "" },
                { attribute: "aNIaNqGn92L", value: row[5] || "" },
                { attribute: "ACV6gQvl2H9", value: row[6] || "" },
                { attribute: "f0aBWJl90eO", value: row[7] || "" },
                { attribute: "SKeHl5XTZVG", value: row[9] || "" },
                { attribute: "sGe7MGw4BVN", value: row[10] || "" },
                { attribute: "XDjgAYmON2o", value: row[8] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "Cq3sRyzWsDo", value: row[4] || "" },
                        { attribute: "aNIaNqGn92L", value: row[5] || "" },
                        { attribute: "ACV6gQvl2H9", value: row[6] || "" },
                        { attribute: "f0aBWJl90eO", value: row[7] || "" },
                        { attribute: "SKeHl5XTZVG", value: row[9] || "" },
                        { attribute: "sGe7MGw4BVN", value: row[10] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDistrictGeneralPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const parseDistrictLevel = (value) => {
        const mappings = {
            District: "District",
            Metropolitan: "Metropolitan",
            Municipal: "Municipal",
        };

        return mappings[value] || "";
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "snUEn55Te11", value: row[6] || "" },
                { attribute: "pPOoDG2bvmo", value: parseFile(row[4]) },
                { attribute: "nVGQlVwOvld", value: parseDistrictLevel(row[5]) },
                { attribute: "SKeHl5XTZVG", value: row[7] || "" },
                { attribute: "BZbNSkBY5w5", value: row[8] || "" },
                { attribute: "h6jVcd8pSCZ", value: parseCoordinate(row[9]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "snUEn55Te11", value: row[6] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getExpenditurePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Ik7fouv4KOA", value: row[4] || "" },
                { attribute: "b43bkz6RXZp", value: parseNumeric(row[6]) },
                { attribute: "nPF1S77QJlJ", value: parseNumeric(row[7]) },
                { attribute: "RkqGw55wSjg", value: parseNumeric(row[8]) },
                { attribute: "H6w6dGV8Z2h", value: parseNumeric(row[9]) },
                { attribute: "iUIpVf849wt", value: parseNumeric(row[10]) },
                { attribute: "w6nouX0rtwI", value: parseNumeric(row[11]) },
                { attribute: "fGfO0hrRRgq", value: row[5] || "" },
                { attribute: "y8FhVo7h4bT", value: parseNumeric(row[12]) },
                { attribute: "I7FJHirf7vx", value: parseNumeric(row[13]) },
                { attribute: "SmhM5TLddYH", value: parseNumeric(row[14]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "Ik7fouv4KOA", value: row[4] || "" },
                        { attribute: "b43bkz6RXZp", value: parseNumeric(row[6]) },
                        { attribute: "nPF1S77QJlJ", value: parseNumeric(row[7]) },
                        { attribute: "RkqGw55wSjg", value: parseNumeric(row[8]) },
                        { attribute: "H6w6dGV8Z2h", value: parseNumeric(row[9]) },
                        { attribute: "iUIpVf849wt", value: parseNumeric(row[10]) },
                        { attribute: "w6nouX0rtwI", value: parseNumeric(row[11]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDistrictAssemblyDepartmentsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "bRQoKAk6wsQ", value: row[4] || "" },
                { attribute: "xJWv6hywE6t", value: row[5] || "" },
                { attribute: "ZvZNxRhU4VP", value: row[6] || "" },
                { attribute: "XZTj0OIaCW3", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "bRQoKAk6wsQ", value: row[4] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getJobPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "pWkYqcKukAY", value: row[4] || "" },
                { attribute: "OCBgYfq4nyM", value: row[8] || "" },
                { attribute: "gyfJjP84zNY", value: row[6] || "" },
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "kmo4am36IO0", value: row[7] || "" },
                { attribute: "f1V1vDibPCS", value: row[9] || "" },
                { attribute: "J1E8xz9hUfl", value: row[10] || "" },
                { attribute: "pYCLApFzDQJ", value: row[11] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "pWkYqcKukAY", value: row[4] || "" },
                        { attribute: "OCBgYfq4nyM", value: row[8] || "" },
                        { attribute: "gyfJjP84zNY", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getFoodVendorsRegisterPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "YxKVJA1budd", value: row[4] || "" },
                { attribute: "pF64ANEoPYx", value: row[6] || "" },
                { attribute: "IQv3CJDmDna", value: row[5] || "" },
                { attribute: "YqP6CROSeSq", value: row[7] || "" },
                { attribute: "h6jVcd8pSCZ", value: parseCoordinate(row[8]) },
                { attribute: "VjFxjvQk0cO", value: row[9] || "" },
                { attribute: "lgarW8cAulg", value: row[10] || "" },
                { attribute: "IrWHkIny02S", value: row[11] || "" },
                { attribute: "Gfx6GlDNJnT", value: row[12] || "" },
                { attribute: "DtQDOJCAct2", value: parsePositiveInt(row[13]) },
                { attribute: "FBMLDuwpMha", value: parsePositiveInt(row[14]) },
                { attribute: "sGe7MGw4BVN", value: row[15] || "" },
                { attribute: "f0aBWJl90eO", value: parseUniqueTIN(row[16]) },
                { attribute: "L9ZHQjoJzfE", value: row[17] || "" },
                { attribute: "AFgZ6dLBncW", value: row[18] || "" },
                { attribute: "wO2BqNRuILL", value: parseFile(row[19]) },
                { attribute: "NWY9LMko2gQ", value: parseBool(row[20]) },
                { attribute: "fNPStFg1WZL", value: parseBool(row[21]) },
                { attribute: "ZQl1IGDUy4u", value: parseBool(row[22]) },
                { attribute: "Jdkob4wXg1b", value: row[23] || "" },
                { attribute: "NhLS79OdYtg", value: parsePositiveInt(row[24]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "YxKVJA1budd", value: row[4] || "" },
                        { attribute: "pF64ANEoPYx", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getEvaluationAndPMEPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const parseEvaluationType = (value) => {
        const mapping = {
            Evaluation: "Evaluation",
            "Monitoring Evaluation": "Participatory Monitoring Evaluation",
            "Participatory Evaluation": "Participatory Evaluation",
        };

        return mapping[value] || "";
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "PsxxJj3wx44", value: parseEvaluationType(row[4]) },
                { attribute: "hx05ofamA7l", value: row[5] || "" },
                { attribute: "oTcsi23MG05", value: row[6] || "" },
                { attribute: "ECGp5Dsci98", value: row[7] || "" },
                { attribute: "FB3EHelJc3s", value: row[8] || "" },
                { attribute: "rxta8ovzPOU", value: row[9] || "" },
                { attribute: "Nucps6dfRKm", value: row[10] || "" },
                { attribute: "DL9jvB5DFJJ", value: row[11] || "" },
                { attribute: "WGmQWjynmrn", value: row[12] || "" },
                { attribute: "NgkaHPzEGPM", value: row[13] || "" },
                { attribute: "YcoTv20WMiO", value: row[14] || "" },
                { attribute: "G0tGOE5UsOg", value: row[15] || "" },
                { attribute: "fGfO0hrRRgq", value: row[16] || "" },
                { attribute: "YfoGKu8N6An", value: row[17] || "" },
                { attribute: "Ax9xIaMCs52", value: parseFile(row[18]) },
                { attribute: "jtoMESZwY58", value: parseFile(row[19]) },
                { attribute: "OxK7S6eyZis", value: parseFile(row[20]) },
                { attribute: "fAJMRMzoFez", value: row[21] || "" },
                { attribute: "KfYBTZsE4gK", value: parseFile(row[22]) },
                { attribute: "niTuRjlNLym", value: parseFile(row[23]) },
                { attribute: "V81KdyYKmPm", value: parseFile(row[24]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "PsxxJj3wx44", value: parseEvaluationType(row[4]) },
                        { attribute: "hx05ofamA7l", value: row[5] || "" },
                        { attribute: "oTcsi23MG05", value: row[6] || "" },
                        { attribute: "ECGp5Dsci98", value: row[7] || "" },
                        { attribute: "FB3EHelJc3s", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDumpingSiteOrEngineeredLandfillsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[4] || "" },
                { attribute: "vIkEALDVio6", value: row[5] || "" },
                { attribute: "XgZK7dL7XeI", value: parseBool(row[6]) },
                { attribute: "kLrk8oInbNY", value: row[10] || "" },
                { attribute: "SbhCyq5YIw6", value: parseBool(row[12]) },
                { attribute: "ihwNh0qiX0W", value: parseBool(row[13]) },
                { attribute: "Rh9laTzbNnz", value: row[7] || "" },
                { attribute: "ydFU2ZUEl4V", value: row[8] || "" },
                { attribute: "NoK1DjRAofh", value: row[9] || "" },
                { attribute: "cPGCeyMceZl", value: parseCoordinate(row[11]) },
                { attribute: "YqP6CROSeSq", value: row[14] || "" },
                { attribute: "XDjgAYmON2o", value: row[15] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[4] || "" },
                        { attribute: "vIkEALDVio6", value: row[5] || "" },
                        { attribute: "XgZK7dL7XeI", value: parseBool(row[6]) },
                        { attribute: "kLrk8oInbNY", value: row[10] || "" },
                        { attribute: "SbhCyq5YIw6", value: parseBool(row[12]) },
                        { attribute: "ihwNh0qiX0W", value: parseBool(row[13]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDPATScoringSheetPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "pWkYqcKukAY", value: row[4] || "" },
                { attribute: "B7jdqUI7GCR", value: parsePositiveInt(row[5]) || 0 },
                { attribute: "VG5LYobYDbk", value: parsePositiveInt(row[6]) || 0 },
                { attribute: "iST35r1RAuK", value: parsePositiveInt(row[7]) || 0 },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "pWkYqcKukAY", value: row[4] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getInspectorateUnitActivityPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "YfoGKu8N6An", value: row[4] || "" },
                { attribute: "Ituuy7n8JGg", value: row[5] || "" },
                { attribute: "ZERTtsbXXc7", value: row[8] || "" },
                { attribute: "XDjgAYmON2o", value: row[9] || "" },
                { attribute: "IsUOT8aa9xW", value: row[12] || "" },
                { attribute: "G0tGOE5UsOg", value: row[13] || "" },
                { attribute: "cu7n4P98dsa", value: row[6] || "" },
                { attribute: "f1V1vDibPCS", value: row[7] || "" },
                { attribute: "cPGCeyMceZl", value: parseCoordinate(row[10]) },
                { attribute: "FU78t4lTqTx", value: row[11] || "" },
                { attribute: "Ax9xIaMCs52", value: parseFile(row[14]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "YfoGKu8N6An", value: row[4] || "" },
                        { attribute: "Ituuy7n8JGg", value: row[5] || "" },
                        { attribute: "ZERTtsbXXc7", value: row[8] || "" },
                        { attribute: "XDjgAYmON2o", value: row[9] || "" },
                        { attribute: "IsUOT8aa9xW", value: row[12] || "" },
                        { attribute: "bR0F7QVZjXC", value: row[13] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getKeyCriticalPovertyIssuesPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "AVnIp8rij7C", value: row[5] || "" },
                { attribute: "S2QBmG02ok2", value: row[4] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "AVnIp8rij7C", value: row[5] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getPermitsRequestPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "YfoGKu8N6An", value: row[5] || "" },
                { attribute: "wca7mlI2exE", value: row[6] || "" },
                { attribute: "FuOpGyKgvyG", value: row[7] || "" },
                { attribute: "LNAq7fnyatP", value: row[8] || "" },
                { attribute: "pWkYqcKukAY", value: row[10] || "" },
                { attribute: "HfzMa3hSgln", value: row[11] || "" },
                { attribute: "LEV8QecVUev", value: row[12] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "IymGu0GBHJk", value: parsePositiveInt(row[9]) || 0 },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "YfoGKu8N6An", value: row[5] || "" },
                        { attribute: "wca7mlI2exE", value: row[6] || "" },
                        { attribute: "FuOpGyKgvyG", value: row[7] || "" },
                        { attribute: "LNAq7fnyatP", value: row[8] || "" },
                        { attribute: "pWkYqcKukAY", value: row[10] || "" },
                        { attribute: "HfzMa3hSgln", value: row[11] || "" },
                        { attribute: "LEV8QecVUev", value: row[12] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getStreetNamingPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Nb0p0tlOqVE", value: row[4] || "" },
                { attribute: "bWDiirSEBSX", value: row[5] || "" },
                { attribute: "pF64ANEoPYx", value: row[6] || "" },
                { attribute: "pL0FwhfkQpm", value: parseBool(row[7]) },
                { attribute: "pya3uRXtS2R", value: parseBool(row[8]) },
                { attribute: "YqP6CROSeSq", value: row[9] || "" },
                { attribute: "cPGCeyMceZl", value: parseCoordinate(row[10]) },
                { attribute: "fGfO0hrRRgq", value: row[11] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "Nb0p0tlOqVE", value: row[4] || "" },
                        { attribute: "bWDiirSEBSX", value: row[5] || "" },
                        { attribute: "pF64ANEoPYx", value: row[6] || "" },
                        { attribute: "pL0FwhfkQpm", value: parseBool(row[7]) },
                        { attribute: "pya3uRXtS2R", value: parseBool(row[8]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getStatutoryMemberPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[4] || "" },
                { attribute: "sGe7MGw4BVN", value: row[5] ? parseInt(row[5].replace(/^0+/, "") || "0", 10) : 0 },
                { attribute: "SKeHl5XTZVG", value: row[6] || "" },
                { attribute: "IQv3CJDmDna", value: row[7] || "" },
                { attribute: "j3CyzRTfdAk", value: row[8] || "" },
                { attribute: "kFAoAaBEqwE", value: row[9] || "" },
                { attribute: "YI5FBDBBU8Z", value: row[10] || "" },
                { attribute: "bSO81USC3ZN", value: row[11] || "" },
                { attribute: "XDjgAYmON2o", value: row[12] || "" },
                { attribute: "Ax9xIaMCs52", value: parseFile(row[13]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[4] || "" },
                        { attribute: "sGe7MGw4BVN", value: row[5] ? parseInt(row[5].replace(/^0+/, "") || "0", 10) : 0 },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getLogisticPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "tcF1c2zJO29", value: row[4] || "" },
                { attribute: "Ik7fouv4KOA", value: row[5] || "" },
                { attribute: "zlmMobounnu", value: row[6] || "" },
                { attribute: "kLaD82vCQLh", value: row[7] || "" },
                { attribute: "x4qBAYjalCD", value: row[8] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "tcF1c2zJO29", value: row[4] || "" },
                        { attribute: "Ik7fouv4KOA", value: row[5] || "" },
                        { attribute: "zlmMobounnu", value: row[6] || "" },
                        { attribute: "kLaD82vCQLh", value: row[7] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getVulnerabilityPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "FtQuKEoL20x", value: row[4] || "" },
                { attribute: "bRQoKAk6wsQ", value: row[5] || "" },
                { attribute: "SKeHl5XTZVG", value: row[6] || "" },
                { attribute: "pF64ANEoPYx", value: row[7] || "" },
                { attribute: "h6jVcd8pSCZ", value: parseCoordinate(row[8]) },
                { attribute: "fGfO0hrRRgq", value: row[9] || "" },
                { attribute: "Ax9xIaMCs52", value: parseFile(row[10]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "FtQuKEoL20x", value: row[4] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getLegalCasePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "K5AYrUoz6EC", value: row[4] || "" },
                { attribute: "AH081uHFEkI", value: row[5] || "" },
                { attribute: "FNC6n574VZa", value: row[6] || "" },
                { attribute: "MOWKE4YxRHp", value: parseBool(row[7]) },
                { attribute: "rqcbVfHltXQ", value: row[8] || "" },
                { attribute: "aGNtk4AMHW7", value: row[9] || "" },
                { attribute: "sFMR9b9DFYo", value: row[10] || "" },
                { attribute: "Vg0UasqsKBQ", value: row[11] || "" },
                { attribute: "Zfsdc8LKrcY", value: row[12] || "" },
                { attribute: "x4qBAYjalCD", value: row[13] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "K5AYrUoz6EC", value: row[4] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getLEDRelatedProgramsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const getLEDMeetingTypeMapping = (value) => {
        const mappings = {
            "Assembly Meeting": "Assembly Meeting",
            "Business Forum": "Business Forum",
            "Community Durbar": "Community Durbar",
            "LED Forum": "LED Forum",
            "Town Hall Meetings": "Town Hall Meetings",
        };

        return mappings[value] || "Other Meeting";
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "YfoGKu8N6An", value: row[4] || "" },
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "tORGLTLHCtn", value: getLEDMeetingTypeMapping(row[7]) },
                { attribute: "x2GKaz9PPqu", value: row[9] || "" },
                { attribute: "nFPavqcYnNs", value: row[13] || "" },
                { attribute: "I8AqLbJESVm", value: row[14] || "" },
                { attribute: "fGfO0hrRRgq", value: row[6] || "" },
                { attribute: "vtjEzZ8uIXx", value: row[8] || "" },
                { attribute: "h6jVcd8pSCZ", value: parseCoordinate(row[10]) },
                { attribute: "FVPxJuIxIrM", value: row[11] || "" },
                { attribute: "meUnqUwQ2ha", value: row[12] || "" },
                { attribute: "Br9IEOZyKPW", value: row[15] || "" },
                { attribute: "dKf1SQYMnnb", value: row[16] || "" },
                { attribute: "x4qBAYjalCD", value: row[17] || "" },
                { attribute: "Tzmw26h9rvx", value: row[18] || "" },
                { attribute: "SiG3jwOG8w2", value: row[19] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "YfoGKu8N6An", value: row[4] || "" },
                        { attribute: "wca7mlI2exE", value: row[5] || "" },
                        { attribute: "tORGLTLHCtn", value: getLEDMeetingTypeMapping(row[7]) },
                        { attribute: "x2GKaz9PPqu", value: row[9] || "" },
                        { attribute: "nFPavqcYnNs", value: row[13] || "" },
                        { attribute: "I8AqLbJESVm", value: row[14] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getPropertyTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Nb0p0tlOqVE", value: row[4] || "" },
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "vIkEALDVio6", value: row[7] || "" },
                { attribute: "KeSsfvs1awo", value: row[6] || "" },
                { attribute: "bWDiirSEBSX", value: row[8] || "" },
                { attribute: "zzT3Eg2Cwuy", value: row[9] || "" },
                { attribute: "OsW4vEs9VL0", value: parseNumeric(row[10]) },
                { attribute: "jX9DTUsh6mx", value: parseCoordinate(row[11]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "Nb0p0tlOqVE", value: row[4] || "" },
                        { attribute: "wca7mlI2exE", value: row[5] || "" },
                        { attribute: "vIkEALDVio6", value: row[7] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getMarketingBusinessTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const getQualityStandardMapping = (value) => {
        const mappings = {
            "EU Standards": "EU Standard",
            "US Standards": "US Standards",
            "GH Standards": "GH Standards",
            "Other (Specify)": "Other (Specify)",
        };

        return mappings[value] || value;
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "ttyKWvSBAZH", value: row[4] || "" },
                { attribute: "VIU6RY5WpCP", value: row[5] || "" },
                { attribute: "Dy3Xf20x913", value: row[8] || "" },
                { attribute: "bh6EtWj6etP", value: getQualityStandardMapping(row[9]) },
                { attribute: "sGe7MGw4BVN", value: row[19] ? parseInt(row[19].replace(/^0+/, "") || "0", 10) : 0 },
                { attribute: "nynzYpVAPSv", value: row[6] || "" },
                { attribute: "oqLQ7vkqJke", value: row[7] || "" },
                { attribute: "K3sY2afSJ65", value: row[10] || "" },
                { attribute: "mw1gCNMOvju", value: row[11] || "" },
                { attribute: "IQv3CJDmDna", value: row[12] || "" },
                { attribute: "f0aBWJl90eO", value: row[13] || "" },
                { attribute: "OoXObWSFTiE", value: row[14] || "" },
                { attribute: "YqP6CROSeSq", value: row[15] || "" },
                { attribute: "XDjgAYmON2o", value: row[16] || "" },
                { attribute: "SKeHl5XTZVG", value: row[17] || "" },
                { attribute: "vUVEUS3VXbF", value: row[18] || "" },
                { attribute: "h6jVcd8pSCZ", value: parseCoordinate(row[20]) },
                { attribute: "LJsIpMkGOJF", value: parseBool(row[21]) },
                { attribute: "DWozHg6rSXy", value: row[22] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "ttyKWvSBAZH", value: row[4] || "" },
                        { attribute: "VIU6RY5WpCP", value: row[5] || "" },
                        { attribute: "Dy3Xf20x913", value: row[8] || "" },
                        { attribute: "bh6EtWj6etP", value: getQualityStandardMapping(row[9]) },
                        { attribute: "sGe7MGw4BVN", value: row[19] ? parseInt(row[19].replace(/^0+/, "") || "0", 10) : 0 },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getPaymentPointPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const getPaymentPointTypeMapping = (value) => {
        const mappings = {
            District: "D",
            Metropolitan: "M",
            Municipal: "Mn",
            Other: "O",
        };

        return mappings[value] || value;
    };

    const getPaymentPointSiteMapping = (value) => {
        const mappings = {
            "Outside the Assembly Premisses": "Outside",
            "Within the Assembly Premisses": "Within",
        };

        return mappings[value] || value;
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "rMNArgwjSNi", value: getPaymentPointTypeMapping(row[6]) },
                { attribute: "cOxc3578azW", value: getPaymentPointSiteMapping(row[10]) },
                { attribute: "xrpTPu2RvpC", value: row[4] || "" },
                { attribute: "f1V1vDibPCS", value: row[7] || "" },
                { attribute: "pF64ANEoPYx", value: row[8] || "" },
                { attribute: "cPGCeyMceZl", value: parseCoordinate(row[9]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[5] || "" },
                        { attribute: "rMNArgwjSNi", value: getPaymentPointTypeMapping(row[6]) },
                        { attribute: "cOxc3578azW", value: getPaymentPointSiteMapping(row[10]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getAuditIssuesPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "WYgiGtg3fbF", value: row[4] || "" },
                { attribute: "Ik7fouv4KOA", value: row[8] || "" },
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "fGfO0hrRRgq", value: row[6] || "" },
                { attribute: "bZCYo3nyrum", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "WYgiGtg3fbF", value: row[4] || "" },
                        { attribute: "Ik7fouv4KOA", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getAnnualProgressReportPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "IHP9xBgvYu7", value: row[4] || "" },
                { attribute: "fGfO0hrRRgq", value: row[5] || "" },
                { attribute: "Uh9i4InWdbN", value: row[6] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "IHP9xBgvYu7", value: row[4] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getRevenuePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "Ik7fouv4KOA", value: row[4] || "" },
                { attribute: "fGfO0hrRRgq", value: row[5] || "" },
                { attribute: "wvkcmief4Md", value: parseNumeric(row[6]) },
                { attribute: "dFUhZ0RTNm1", value: parseNumeric(row[7]) },
                { attribute: "ERzBEeWqm8v", value: parseNumeric(row[8]) },
                { attribute: "WPgMygTaQPE", value: parseNumeric(row[9]) },
                { attribute: "mil8GQUWXKn", value: parseNumeric(row[10]) },
                { attribute: "YKkbeT1cWxq", value: parseNumeric(row[11]) },
                { attribute: "zV8GC0aTfMx", value: parseNumeric(row[12]) },
                { attribute: "fzmOUbl4xJ4", value: parseNumeric(row[13]) },
                { attribute: "ZQTg0EJma86", value: parseNumeric(row[14]) },
                { attribute: "ILzpS1dryP7", value: parseNumeric(row[15]) },
                { attribute: "GV4Azm9cqym", value: parseNumeric(row[16]) },
                { attribute: "n1YNAjagk9P", value: parseNumeric(row[17]) },
                { attribute: "v6RSxf0H9rv", value: parseNumeric(row[18]) },
                { attribute: "D1nrnwEd9NR", value: parseNumeric(row[19]) },
                { attribute: "Qy9R3DHPDCU", value: parseNumeric(row[20]) },
                { attribute: "Q33KoLkJoud", value: parseNumeric(row[21]) },
                { attribute: "KLzJohYEAeC", value: parseNumeric(row[22]) },
                { attribute: "XM0aRSGYvCG", value: parseNumeric(row[23]) },
                { attribute: "bhQtVq03XnY", value: parseNumeric(row[24]) },
                { attribute: "FevvxT7CDep", value: parseNumeric(row[25]) },
                { attribute: "FbosSuT4jaL", value: parseNumeric(row[26]) },
                { attribute: "T0dM7hVCbHR", value: parseNumeric(row[27]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "Ik7fouv4KOA", value: row[4] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getPublicationsPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const getPublicationChannelMapping = (value) => {
        const mappings = {
            "Social Media": "Others",
            Website: "Website",
            Newspaper: "Newspaper",
            "Notice Board": "Notice Board",
            "Website and Notice Board": "Website and Notice Board",
            "Media Station": "Media Station",
            "Multi-Channel": "Multi-Channel",
            Others: "Others",
        };

        return mappings[value] || "Others";
    };

    const formatDate = (dateStr) => {
        if (!dateStr || dateStr === "-") return "";

        const parts = String(dateStr).split("-");
        if (parts.length === 3) {
            const year = parts[0];
            const month = parts[1].padStart(2, "0");
            const day = parts[2].padStart(2, "0");
            return `${year}-${month}-${day}`;
        }

        return dateStr;
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "ozmSnpGukjT", value: formatDate(row[4]) },
                { attribute: "VYCQ5lh0HdP", value: getPublicationChannelMapping(row[5]) },
                { attribute: "Iu8c8cj8Dyy", value: row[8] || "" },
                { attribute: "esLqs2on3wb", value: row[6] || "" },
                { attribute: "PcAeFR1VZmn", value: row[7] || "" },
                { attribute: "dLpaJdUcdI1", value: parseFile(row[9]) },
                { attribute: "h2qzIw9348I", value: parseBool(row[10]) },
                { attribute: "VVe0mEoykVD", value: formatDate(row[11]) },
                { attribute: "usccm7IEAoD", value: row[12] || "" },
                { attribute: "c4ZR8yj3VZH", value: row[13] || "" },
                { attribute: "sL5SfjbM6yv", value: parseBool(row[14]) },
                { attribute: "CGzoXfumfSl", value: formatDate(row[15]) },
                { attribute: "gGPbCe38wqg", value: row[16] || "" },
                { attribute: "Jc3p19yBvnN", value: parseBool(row[17]) },
                { attribute: "VaAsLRhe81v", value: formatDate(row[18]) },
                { attribute: "pXBfRA6syLE", value: row[19] || "" },
                { attribute: "RtVONJyhKAh", value: formatDate(row[20]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "ozmSnpGukjT", value: formatDate(row[4]) },
                        { attribute: "VYCQ5lh0HdP", value: getPublicationChannelMapping(row[5]) },
                        { attribute: "Iu8c8cj8Dyy", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSanitationAndWasteTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [{ attribute: "YfoGKu8N6An", value: row[5] || "" }],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "YfoGKu8N6An", value: row[5] || "" }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSocialInclusiveProgramTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const parseNumber = (value) => {
        if (!value || value === "-" || value === "") return "";
        const cleanValue = String(value).replace(/[^0-9]/g, "");
        const num = parseInt(cleanValue, 10);
        return Number.isNaN(num) || num < 0 ? "" : num.toString();
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "CxW1R33QUV2", value: row[5] || "" },
                { attribute: "FVPxJuIxIrM", value: row[7] || "" },
                { attribute: "ZERTtsbXXc7", value: row[9] || "" },
                { attribute: "n7h6V5qo8Td", value: parseNumber(row[10]) },
                { attribute: "mdO1ngv0Qt0", value: parseNumber(row[13]) },
                { attribute: "gkqU35LKO4t", value: row[14] || "" },
                { attribute: "qkHXURztKyc", value: row[15] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "ZXbvKuyurxe", value: row[6] || "" },
                { attribute: "Z4ibyZpPR1T", value: row[8] || "" },
                { attribute: "ilVNpuD0NUj", value: parseNumber(row[11]) },
                { attribute: "N2RLXZiGLBy", value: parseNumber(row[12]) },
                { attribute: "x4qBAYjalCD", value: row[16] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "CxW1R33QUV2", value: row[5] || "" },
                        { attribute: "FVPxJuIxIrM", value: row[7] || "" },
                        { attribute: "ZERTtsbXXc7", value: row[9] || "" },
                        { attribute: "n7h6V5qo8Td", value: parseNumber(row[10]) },
                        { attribute: "mdO1ngv0Qt0", value: parseNumber(row[13]) },
                        { attribute: "gkqU35LKO4t", value: row[14] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSubStructureActivityTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const getFundingSourceMapping = (value) => {
        if (!value || value === "-") return "";

        const mappings = {
            "2% of DACF": "DACF",
            DACF: "DACF",
            "Revenue Ceded": "Revenue Ceded",
            IGF: "Revenue Ceded",
            "Internally Generated Fund": "Revenue Ceded",
            Other: "Revenue Ceded",
        };

        const lowerValue = String(value).toLowerCase();
        if (lowerValue.includes("dacf")) return "DACF";
        if (lowerValue.includes("revenue") || lowerValue.includes("igf")) return "Revenue Ceded";

        return mappings[value] || "Revenue Ceded";
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "sI8Kj3pfa6k", value: row[4] || "" },
                { attribute: "hQVox0xawJI", value: row[5] || "" },
                { attribute: "VjFxjvQk0cO", value: row[8] || "" },
                { attribute: "PReqkv3CYaE", value: getFundingSourceMapping(row[6]) },
                { attribute: "YfoGKu8N6An", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "sI8Kj3pfa6k", value: row[4] || "" },
                        { attribute: "hQVox0xawJI", value: row[5] || "" },
                        { attribute: "VjFxjvQk0cO", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSubStructureCommitteePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "sI8Kj3pfa6k", value: row[4] || "" },
                { attribute: "HpWdkwq4K4Q", value: row[5] || "" },
                { attribute: "AlVMRjjWuVo", value: row[7] || "" },
                { attribute: "f1V1vDibPCS", value: row[6] || "" },
                { attribute: "yWbhfTquC4O", value: row[8] || "" },
                { attribute: "bSO81USC3ZN", value: row[9] || "" },
                { attribute: "bIGyTZp8ORb", value: row[10] || "" },
                { attribute: "sGe7MGw4BVN", value: row[11] || "" },
                { attribute: "h6jVcd8pSCZ", value: parseCoordinate(row[12]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "sI8Kj3pfa6k", value: row[4] || "" },
                        { attribute: "HpWdkwq4K4Q", value: row[5] || "" },
                        { attribute: "AlVMRjjWuVo", value: row[7] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getTestFruitApplicationPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "JsjIwEt18J0", value: parseBool(row[4]) },
                { attribute: "mB5J8mki06Q", value: row[5] || "" },
                { attribute: "N4S0i2fi0xa", value: row[6] || "" },
                { attribute: "fNavKvngj9W", value: parseBool(row[7]) },
                { attribute: "GwCgBmiICKl", value: parseBool(row[8]) },
                { attribute: "Z7Fgg9OWyHg", value: parseBool(row[9]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [{ attribute: "JsjIwEt18J0", value: parseBool(row[4]) }],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getResidentialHomeCentrePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[4] || "" },
                { attribute: "sGe7MGw4BVN", value: parseNumeric(row[8]) },
                { attribute: "BZbNSkBY5w5", value: row[9] || "" },
                { attribute: "SKeHl5XTZVG", value: row[5] || "" },
                { attribute: "pF64ANEoPYx", value: row[6] || "" },
                { attribute: "YqP6CROSeSq", value: row[7] || "" },
                { attribute: "XDjgAYmON2o", value: row[10] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[4] || "" },
                        { attribute: "sGe7MGw4BVN", value: parseNumeric(row[8]) },
                        { attribute: "BZbNSkBY5w5", value: row[9] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getUserProfilePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "yPvU4sPN9hh", value: row[4] || "" },
                { attribute: "PtqWutejid0", value: row[5] || "" },
                { attribute: "j3CyzRTfdAk", value: row[6] || "" },
                { attribute: "MQ7qa7gOxzb", value: row[7] || "" },
                { attribute: "sGe7MGw4BVN", value: parseNumeric(row[8]) },
                { attribute: "mUHeOAckLf1", value: row[9] || "" },
                { attribute: "Ax9xIaMCs52", value: parseFile(row[10]) },
                { attribute: "mewas520GEZ", value: row[11] || "" },
                { attribute: "XsUFsoszfgr", value: row[12] || "" },
                { attribute: "Ada5shKwWZB", value: row[13] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "yPvU4sPN9hh", value: row[4] || "" },
                        { attribute: "PtqWutejid0", value: row[5] || "" },
                        { attribute: "j3CyzRTfdAk", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getDocumentsHubPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const getDocumentTypeMapping = (value) => {
        if (!value || value === "-" || value === "") return "Financial Reports";

        const validTypes = [
            "Adherence to Occupational Health and Safety Standards",
            "Annual Action Plan Progress Report",
            "Annual Progress Report",
            "Annual Progress Reports on PWD",
            "Approved Assemblies Client Service Charter",
            "Auditor-General Reports",
            "Business Forum Meeting Report",
            "Certification reports on food vendors",
            "Climate Adaptation Report",
            "Climate change activity reports",
            "CSU activity report",
            "Disaster Risk Reduction and Management Plan (DRRMP)",
            "District Education Progress Reports",
            "District Health Progress Reports",
            "Documents on industrial enclave",
            "Electricity Service Provider",
            "Emergency Response Preparedness Plan",
            "Environmental Health Reports",
            "File on ceded revenue",
            "Food and Beverage Vendors Monitoring Report",
            "Housing Reports",
            "Implementation of Decisions by General Assembly & Management Report",
            "Implementation Report",
            "Internal Audit Report for 2021",
            "Land Use Progress reports",
            "LED Activities Report",
            "LED Activity Report",
            "Liquid and Solid Waste disposal reports",
            "Local Planning Scheme",
            "Minutes of Town Hall Meetings",
            "MMDCE's itinerary for Community Engagements Annual Progress Reports (APR)",
            "Monitoring Checklist and Report",
            "Monitoring, Building and Inspection  Reports",
            "OHLGS Training Report",
            "Operations and Maintenance Plan",
            "Payment Points Report",
            "Procurement Plan",
            "Register for Public Transport",
            "Reports of Community engagements",
            "Reports on agricultural activities",
            "Reports on Communal service",
            "Reports on Investor Engagements",
            "Revenue Improvement Action Plan",
            "Sanitation Monitoring Reports",
            "Sanitation Reports",
            "Sanitation Service Provider",
            "Schools Reports",
            "Social Services activity implementation Reports",
            "Social Welfare Progress Report",
            "Street Names and Report on installation of street addressing/directional signage",
            "Support to Health Centre Reports",
            "Training Impact assessment reports",
            "Client Service Unit Report",
            "Water Service Provider",
            "Medium Term Development Plan (MTDP)",
            "Capacity Building Report",
            "Financial Reports",
        ];

        if (value === "Sanitation Service Provider Reports") return "Sanitation Service Provider";

        return validTypes.includes(value) ? value : "Financial Reports";
    };

    const parseVersion = (value) => {
        if (!value || value === "-" || value === "") return "";
        const num = Math.floor(parseFloat(value));
        return Number.isNaN(num) || num <= 0 ? "" : num.toString();
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[4] || "" },
                { attribute: "HegQ9f2EvbC", value: getDocumentTypeMapping(row[5]) },
                { attribute: "wPNjapyO0Jl", value: row[6] || "" },
                { attribute: "iSGLs8Qaq7E", value: row[7] || "" },
                { attribute: "tigrJR4126b", value: row[8] || "" },
                { attribute: "fvOjwBcpEMV", value: row[9] || "" },
                { attribute: "MZWUSf9PCHv", value: parseVersion(row[10]) },
                { attribute: "RtVONJyhKAh", value: row[11] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[4] || "" },
                        { attribute: "HegQ9f2EvbC", value: getDocumentTypeMapping(row[5]) },
                        { attribute: "wPNjapyO0Jl", value: row[6] || "" },
                        { attribute: "iSGLs8Qaq7E", value: row[7] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getInspectorateUnitEstablishmentTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "AlVMRjjWuVo", value: row[4] || "" },
                { attribute: "RXTTz95xaoO", value: row[5] || "" },
                { attribute: "w9leRrwWrLB", value: parseBool(row[6]) },
                { attribute: "fGfO0hrRRgq", value: row[7] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "AlVMRjjWuVo", value: row[4] || "" },
                        { attribute: "RXTTz95xaoO", value: row[5] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getInternallyGeneratedFundTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const enrolledAt = row[2] && row[2] !== "-" && String(row[2]).trim() !== "" ? row[2] : "2025-01-01T00:00:00.000";
        const occurredAt = row[3] && row[3] !== "-" && String(row[3]).trim() !== "" ? row[3] : "2025-01-01T00:00:00.000";

        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "pWkYqcKukAY", value: row[4] || "" },
                { attribute: "jcFWiKH0Kud", value: row[5] || "" },
                { attribute: "tsmYBpRcYxU", value: row[6] || "" },
                { attribute: "xSAif899MME", value: row[7] || "" },
                { attribute: "nlZbT98zSio", value: row[8] || "" },
                { attribute: "x4qBAYjalCD", value: row[9] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt,
                    occurredAt,
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "pWkYqcKukAY", value: row[4] || "" },
                        { attribute: "jcFWiKH0Kud", value: row[5] || "" },
                        { attribute: "tsmYBpRcYxU", value: row[6] || "" },
                        { attribute: "xSAif899MME", value: row[7] || "" },
                        { attribute: "nlZbT98zSio", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getOneDistrictOneWarehouseTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "YLKXcF4M13E", value: row[4] || "" },
                { attribute: "DdrX62P5Fnm", value: row[5] || "" },
                { attribute: "tTbvdaHiwu2", value: row[6] || "" },
                { attribute: "xzxLzkpzWsc", value: row[7] || "" },
                { attribute: "IhvthaZKFv5", value: row[8] || "" },
                { attribute: "C3p06b9wwvc", value: row[9] || "" },
                { attribute: "MotoRaHYNig", value: row[10] || "" },
                { attribute: "HpEdGx1AVWM", value: row[11] || "" },
                { attribute: "zFxTIbayz4U", value: row[12] || "" },
                { attribute: "VjFxjvQk0cO", value: row[13] || "" },
                { attribute: "cPGCeyMceZl", value: parseCoordinate(row[14]) },
                { attribute: "wO2BqNRuILL", value: parseFile(row[15]) },
                { attribute: "S3O6siQ5UBo", value: row[16] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "YLKXcF4M13E", value: row[4] || "" },
                        { attribute: "DdrX62P5Fnm", value: row[5] || "" },
                        { attribute: "tTbvdaHiwu2", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getSocialInclusiveProgramBeneficiariesTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "yPvU4sPN9hh", value: row[5] || "" },
                { attribute: "PtqWutejid0", value: row[6] || "" },
                { attribute: "j3CyzRTfdAk", value: row[7] || "" },
                { attribute: "UJBblniqPOI", value: row[8] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "HgemfhhsXBc", value: row[9] || "" },
                { attribute: "vUVEUS3VXbF", value: row[10] || "" },
                { attribute: "SKeHl5XTZVG", value: row[11] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "yPvU4sPN9hh", value: row[5] || "" },
                        { attribute: "PtqWutejid0", value: row[6] || "" },
                        { attribute: "j3CyzRTfdAk", value: row[7] || "" },
                        { attribute: "UJBblniqPOI", value: row[8] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getCommunityProfilePayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[5] || "" },
                { attribute: "qdDngSjZY9H", value: row[6] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "jX9DTUsh6mx", value: parseCoordinate(row[7]) },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[5] || "" },
                        { attribute: "qdDngSjZY9H", value: row[6] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getClientServiceUnitTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "KKvCqPE0o4r", value: parseBool(row[5]) },
                { attribute: "AfBfUzcvMVC", value: parseBool(row[6]) },
                { attribute: "YPoOqFSzwjc", value: parseBool(row[7]) },
                { attribute: "HnIZkFq81E4", value: row[8] || "" },
                { attribute: "Xwogv0s7lDX", value: row[9] || "" },
                { attribute: "AlVMRjjWuVo", value: row[4] || "" },
                { attribute: "SKeHl5XTZVG", value: row[10] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "KKvCqPE0o4r", value: parseBool(row[5]) },
                        { attribute: "AfBfUzcvMVC", value: parseBool(row[6]) },
                        { attribute: "YPoOqFSzwjc", value: parseBool(row[7]) },
                        { attribute: "HnIZkFq81E4", value: row[8] || "" },
                        { attribute: "Xwogv0s7lDX", value: row[9] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getATSheetTrainingAttendanceSheetTrackerPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const parseDesignationMapping = (value) => {
        const mappings = {
            Director: "Director",
            "Accounts Officer": "Accounts Officer",
            Other: "Other",
            "Other (Specify)": "Other",
        };

        return mappings[value] || "Other";
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "s0psXh4E3zv", value: row[4] || "" },
                { attribute: "deLo7BbZ8Z3", value: row[5] || "" },
                { attribute: "J7IrEy5foBT", value: parseDesignationMapping(row[6]) },
                { attribute: "HgemfhhsXBc", value: parseNumeric(row[7]) },
                { attribute: "SKeHl5XTZVG", value: row[8] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "s0psXh4E3zv", value: row[4] || "" },
                        { attribute: "deLo7BbZ8Z3", value: row[5] || "" },
                        { attribute: "J7IrEy5foBT", value: parseDesignationMapping(row[6]) },
                        { attribute: "HgemfhhsXBc", value: parseNumeric(row[7]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getAgriculturalExtensionandSupportOfficersPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    const parseOfficerPosition = (value) => {
        const mappings = {
            "District Director of Agriculture (DDA)": "District Director of Agriculture (DDA)",
            "District Agric. Officer (DAO)": "District Agric. Officer (DAO)",
            "Agric. Extension Agent (AEA)": "Agric. Extension Agent (AEA)",
            "Veterinary officer (s)": "Veterinary officer (s)",
            "Veterinary officer (DAO)": "Veterinary officer (s)",
            "Women in Agricultural Development (WIAD) officer": "Women in Agricultural Development (WIAD) officer",
            "Livestock (DAO)": "Livestock (DAO)",
            "Crops (DAO)": "Crops (DAO)",
            "MIS Officer (DAO)": "MIS Officer (DAO)",
            "Fisheries (DAO)": "Fisheries (DAO)",
            "Other (specify)": "Other (specify)",
        };

        return mappings[value] || "Other (specify)";
    };

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "yPvU4sPN9hh", value: row[5] || "" },
                { attribute: "PtqWutejid0", value: row[6] || "" },
                { attribute: "j3CyzRTfdAk", value: row[7] || "" },
                { attribute: "IztkGQj5EqM", value: row[4] || "" },
                { attribute: "MQ7qa7gOxzb", value: row[8] || "" },
                { attribute: "Ax9xIaMCs52", value: parseFile(row[9]) },
                { attribute: "HgemfhhsXBc", value: parseNumeric(row[10]) },
                { attribute: "SKeHl5XTZVG", value: row[11] || "" },
                { attribute: "IQv3CJDmDna", value: row[12] || "" },
                { attribute: "YqP6CROSeSq", value: row[13] || "" },
                { attribute: "vUVEUS3VXbF", value: row[14] || "" },
                { attribute: "MlZZaEBs9uC", value: row[15] || "" },
                { attribute: "gpfdSyKVC9R", value: parseOfficerPosition(row[16]) },
                { attribute: "ijaTnXxuWKJ", value: row[17] || "" },
                { attribute: "uOSiNltNDjn", value: row[18] || "" },
                { attribute: "I0z9Oq0lrj8", value: row[19] || "" },
                { attribute: "kuqX8ZqvbhS", value: row[20] || "" },
                { attribute: "eYhNbIb7nYk", value: row[21] || "" },
                { attribute: "SbsvgoYMOps", value: row[22] || "" },
                { attribute: "saSCm0QDfyU", value: row[23] || "" },
                { attribute: "q88J6EIuC5p", value: parseCoordinate(row[24]) },
                { attribute: "x4qBAYjalCD", value: row[25] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "yPvU4sPN9hh", value: row[5] || "" },
                        { attribute: "PtqWutejid0", value: row[6] || "" },
                        { attribute: "j3CyzRTfdAk", value: row[7] || "" },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getProgramPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes: [
                { attribute: "wca7mlI2exE", value: row[4] || "" },
                { attribute: "Y7ts1V4n4Gc", value: row[6] || "" },
                { attribute: "k0JMgRqxmiJ", value: getProgramTypeMapping(row[12]) },
                { attribute: "XDjgAYmON2o", value: row[5] || "" },
                { attribute: "FVPxJuIxIrM", value: row[7] || "" },
                {
                    attribute: "JDAhouXsGGO",
                    value: row[9] === "-" ? null : row[9] === "Yes" ? true : row[9] === "No" ? false : null,
                },
                { attribute: "QRX2hooQpCo", value: row[11] || "" },
                { attribute: "MjCjeCH2TbP", value: row[13] || "" },
                { attribute: "EKTp0a9qtum", value: row[14] || "" },
                { attribute: "Ax9xIaMCs52", value: "" },
                { attribute: "I8AqLbJESVm", value: row[16] || "" },
                { attribute: "nFPavqcYnNs", value: row[17] || "" },
            ],
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] && row[2] !== "-" ? row[2] : "2025-01-01T00:00:00.000",
                    occurredAt: row[3] && row[3] !== "-" ? row[3] : "2025-01-01T00:00:00.000",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "wca7mlI2exE", value: row[4] || "" },
                        { attribute: "Y7ts1V4n4Gc", value: row[6] || "" },
                        { attribute: "k0JMgRqxmiJ", value: getProgramTypeMapping(row[12]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

export const getProjectPayload = (data, orgUnit, program, trackedEntityType) => {
    const payload = [];

    data.forEach((row) => {
        const projectId = generateProjectId();
        const attributes = [
            { attribute: "s9DLL3i1DoG", value: projectId },
            { attribute: "wca7mlI2exE", value: clean(row[7]) },
            { attribute: "pF64ANEoPYx", value: clean(row[10]) },
            { attribute: "XlP38Ti4IDm", value: clean(row[12]) },
            { attribute: "HBT45AEPUEY", value: clean(row[15]) },
            { attribute: "Gjp3MCitNjZ", value: row[18] === "-" ? 0 : row[18] },
            { attribute: "lXixoqQDyMf", value: clean(row[19]) },
            { attribute: "FVPxJuIxIrM", value: clean(row[20]) },
            { attribute: "nqfJw87a0OY", value: clean(row[5]) },
            { attribute: "wtf3BR2YO8w", value: clean(row[6]) },
            { attribute: "fGfO0hrRRgq", value: clean(row[8]) },
            { attribute: "x4qBAYjalCD", value: clean(row[9]) },
            { attribute: "k921oNWPSd4", value: clean(row[13]) },
            { attribute: "EkU6HmV2UhW", value: clean(row[16]) },
            { attribute: "Xlu1Z8uDhbU", value: clean(row[17]) },
            { attribute: "TbBnbZpfSB0", value: clean(row[21]) },
            { attribute: "laeUzGtaHGQ", value: row[22] === "-" ? 0 : row[22] },
            { attribute: "SJhftGrkUr4", value: clean(row[23]) },
            { attribute: "VT3vVii1aCg", value: row[24] === "-" ? 0 : row[24] },
            { attribute: "UGSorHuKv95", value: clean(row[25]) },
            { attribute: "ILWcSvIhjql", value: row[26] === "-" ? 0 : row[26] },
            { attribute: "JgjD9cTUbhm", value: clean(row[30]) },
            { attribute: "T7LiYCQ3LAm", value: clean(row[31]) },
            { attribute: "gkqU35LKO4t", value: clean(row[32]) },
            { attribute: "qkHXURztKyc", value: clean(row[33]) },
            { attribute: "hSgCkWoDT1D", value: clean(row[34]) },
            { attribute: "kGdgXatUQ8a", value: clean(row[35]) },
            { attribute: "bzOiJtn6tC4", value: clean(row[37]) },
            { attribute: "bRQoKAk6wsQ", value: clean(row[38]) },
            { attribute: "BcgmVvDqyk0", value: clean(row[39]) },
            { attribute: "W8Wvul1ckiS", value: row[40] === "-" ? 0 : row[40] },
            { attribute: "dWaFloDzwWh", value: row[41] === "-" ? 0 : row[41] },
            { attribute: "UyeEjhOXiyW", value: row[42] === "-" ? 0 : row[42] },
            { attribute: "NfY4xJLSfAf", value: clean(row[43]) },
            { attribute: "r79D4IOU6DU", value: row[44] === "-" ? 0 : row[44] },
        ];

        const tempDataSet = {
            orgUnit,
            trackedEntityType,
            attributes,
            enrollments: [
                {
                    program,
                    orgUnit,
                    enrolledAt: row[2] || "2025-01-01",
                    occurredAt: row[3] || "2025-01-01",
                    status: "ACTIVE",
                    attributes: [
                        { attribute: "s9DLL3i1DoG", value: projectId },
                        { attribute: "wca7mlI2exE", value: clean(row[7]) },
                        { attribute: "pF64ANEoPYx", value: clean(row[10]) },
                        { attribute: "XlP38Ti4IDm", value: clean(row[12]) },
                        { attribute: "HBT45AEPUEY", value: clean(row[15]) },
                        { attribute: "Gjp3MCitNjZ", value: row[18] === "-" ? 0 : row[18] },
                        { attribute: "lXixoqQDyMf", value: clean(row[19]) },
                        { attribute: "FVPxJuIxIrM", value: clean(row[20]) },
                        { attribute: "nqfJw87a0OY", value: clean(row[5]) },
                        { attribute: "wtf3BR2YO8w", value: clean(row[6]) },
                    ],
                },
            ],
        };

        payload.push(tempDataSet);
    });

    return {
        trackedEntities: payload,
    };
};

const TRACKER_MANDATORY_FIELDS = {
    "Projects & Programmes Register (P&P)": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "pF64ANEoPYx", description: "Location" },
        { attribute: "XlP38Ti4IDm", description: "Development Dimension" },
        { attribute: "HBT45AEPUEY", description: "Contractor" },
        { attribute: "Gjp3MCitNjZ", description: "Contract Sum" },
        { attribute: "lXixoqQDyMf", description: "Currency" },
        { attribute: "FVPxJuIxIrM", description: "Primary Funding Source" },
        { attribute: "nqfJw87a0OY", description: "Contract No" },
        { attribute: "wtf3BR2YO8w", description: "Project & Programme Type" },
    ],
    "Annual Action Plan (AAP)": [
        { attribute: "pWkYqcKukAY", description: "Year" },
        { attribute: "IHP9xBgvYu7", description: "Activity Name" },
        { attribute: "VjFxjvQk0cO", description: "Activity Description" },
        { attribute: "Ni5mF1bxTcq", description: "Activity State" },
        { attribute: "vYOjuRKymY8", description: "Focus Activity" },
        { attribute: "JgjD9cTUbhm", description: "Expected Start Date" },
        { attribute: "Go8eelOBPsP", description: "Lead Implementing Agency" },
        { attribute: "IZZ2dtfaCC1", description: "Activity Type" },
    ],
    "District General Tracker": [
        { attribute: "nVGQlVwOvld", description: "District Level" },
        { attribute: "snUEn55Te11", description: "Contact Number" },
        { attribute: "SKeHl5XTZVG", description: "Email Address" },
        { attribute: "BZbNSkBY5w5", description: "Public Hotline" },
    ],
    "Bill Tracker": [
        { attribute: "QUuxyqTen7u", description: "Serial Number" },
        { attribute: "YfoGKu8N6An", description: "Date" },
        { attribute: "TBJZqGzKrLx", description: "Has it been issued" },
        { attribute: "zud2JY8pPTV", description: "Bill Status" },
        { attribute: "hQVox0xawJI", description: "Bill Amount" },
        { attribute: "FuOpGyKgvyG", description: "Purpose" },
    ],
    "Annual Action Plan Baselines and Targets": [
        { attribute: "Ik7fouv4KOA", description: "Year" }
    ],
    "Budget Allocation Tracker": [
        { attribute: "Ik7fouv4KOA", description: "Year" },
        { attribute: "DVNScIHo9ik", description: "Budget Category" },
        { attribute: "t9GmH5N6fuW", description: "Allocated Budget" },
    ],
    "Operational Health Facility Tracker": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "pF64ANEoPYx", description: "Location" },
        { attribute: "KeSsfvs1awo", description: "Owner/leader" },
        { attribute: "vIkEALDVio6", description: "Ownership Type" },
    ],
    "Sport Facility Tracker": [
        { attribute: "d4vGACWAj7R", description: "Name of sport facility" },
        { attribute: "NU2g62mWHJQ", description: "Facility ownership type" },
    ],
    "Service Providers Tracker": [
        { attribute: "Hq8it9qapWz", description: "Service Provider" },
        { attribute: "ttyKWvSBAZH", description: "Name of Business" },
        { attribute: "XDjgAYmON2o", description: "Address location" },
        { attribute: "tb0nGRwpQEw", description: "Period of contract" },
        { attribute: "gkqU35LKO4t", description: "Start date" },
    ],
    "School Profile Tracker": [
        { attribute: "UJBblniqPOI", description: "Community" },
        { attribute: "RYU3GpNzokp", description: "Type" },
    ],
    "Meetings Tracker": [
        { attribute: "eOsejnvfYiV", description: "Invitation letter date" },
        { attribute: "Mm3f9fbAT8r", description: "Invitation letter reference number" },
        { attribute: "rSKzHSBlOyB", description: "Who signed the invitation letter" },
        { attribute: "Ub0V9Z06aBc", description: "Meeting date" },
        { attribute: "kghpIZgHFsT", description: "Meeting type" },
        { attribute: "b7uAJaX9obN", description: "Meeting title" },
        { attribute: "HmdJqjjAZZ4", description: "Meeting venue" },
        { attribute: "Br9IEOZyKPW", description: "Number of decisions" },
        { attribute: "U2RjiIApoYu", description: "Number of Attendance Male" },
        { attribute: "iHz18pXkmMd", description: "Number of Attendance Female" },
    ],
    "People With Disability Tracker": [
        { attribute: "yPvU4sPN9hh", description: "First Name" },
        { attribute: "PtqWutejid0", description: "Last Name" },
        { attribute: "j3CyzRTfdAk", description: "Gender" },
        { attribute: "NA5Bek1ME81", description: "Disability type" },
        { attribute: "yUDWmWXB08P", description: "Does this PWD have a caretaker" },
    ],
    "Program Tracker": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "Y7ts1V4n4Gc", description: "PWD Activity Description" },
        { attribute: "k0JMgRqxmiJ", description: "PWD Program type" },
    ],
    "Boundary Dispute Tracker": [
        { attribute: "mM7z6LuxndL", description: "Does the district have boundary issue" }
    ],
    "Computerized Billing System": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "biAXx5doufe", description: "Developed by" },
        { attribute: "J2GkQ7g6IFk", description: "Purchased cost" },
        { attribute: "RP06q4eZ8Sp", description: "Valid from" },
    ],
    "Capacity Building Needs": [
        { attribute: "VjFxjvQk0cO", description: "Activity Description" },
        { attribute: "Ni5mF1bxTcq", description: "Activity State" },
        { attribute: "nyeFHN5Z9oJ", description: "Activity type" },
        { attribute: "vYOjuRKymY8", description: "Focus activity" },
        { attribute: "wcnA9Wodtf2", description: "Capacity Building Needs from" },
    ],
    "Consulting And Contractors": [
        { attribute: "Cq3sRyzWsDo", description: "Consulting Firm" },
        { attribute: "aNIaNqGn92L", description: "Consulting and contractors agency" },
        { attribute: "ACV6gQvl2H9", description: "Lead consultant" },
        { attribute: "f0aBWJl90eO", description: "TIN" },
        { attribute: "SKeHl5XTZVG", description: "Email Address" },
        { attribute: "sGe7MGw4BVN", description: "Phone" },
    ],
    "Decisions And Complaints": [
        { attribute: "xYKvhN8Oxh8", description: "Meeting type" },
        { attribute: "JRxGCfymyCQ", description: "Type" },
        { attribute: "dKf1SQYMnnb", description: "Decision" },
        { attribute: "CVOeyCI3cvs", description: "Meeting reference number" },
    ],
    "Disaster Tracker": [
        { attribute: "RMSqAr6nFf1", description: "Disaster type" },
        { attribute: "UJBblniqPOI", description: "Community" },
    ],
    "District Assembly Departments": [
        { attribute: "bRQoKAk6wsQ", description: "Department" }
    ],
    "Expenditure Tracker": [
        { attribute: "Ik7fouv4KOA", description: "Select year" },
        { attribute: "b43bkz6RXZp", description: "Compensation baseline" },
        { attribute: "nPF1S77QJlJ", description: "Compensation target" },
        { attribute: "RkqGw55wSjg", description: "Goods and services baseline" },
        { attribute: "H6w6dGV8Z2h", description: "Goods and services target" },
        { attribute: "iUIpVf849wt", description: "Investment/Assets baseline" },
        { attribute: "w6nouX0rtwI", description: "Investment/Assets target" },
    ],
    "Job Tracker": [
        { attribute: "pWkYqcKukAY", description: "Year" },
        { attribute: "OCBgYfq4nyM", description: "Type of resource invested" },
        { attribute: "gyfJjP84zNY", description: "Activity/Type of support" },
    ],
    "Food Vendors Register": [
        { attribute: "YxKVJA1budd", description: "Name of vendor/Business" },
        { attribute: "pF64ANEoPYx", description: "Location" },
    ],
    "Evaluation And PME Tracker": [
        { attribute: "PsxxJj3wx44", description: "Evaluation type" },
        { attribute: "hx05ofamA7l", description: "Evaluation Name" },
        { attribute: "oTcsi23MG05", description: "Policy/programme/project involved" },
        { attribute: "ECGp5Dsci98", description: "Consultant or resource persons involved" },
        { attribute: "FB3EHelJc3s", description: "Methodology used" },
    ],
    "Dumping Site or engineered landfills": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "vIkEALDVio6", description: "Ownership type" },
        { attribute: "XgZK7dL7XeI", description: "Is there a co-ownership for the site" },
        { attribute: "kLrk8oInbNY", description: "Dumping site waste type" },
        { attribute: "SbhCyq5YIw6", description: "Is the site engineered or well-maintained dumping site" },
        { attribute: "ihwNh0qiX0W", description: "Is it EPA certified" },
    ],
    "DPAT Scoring Sheet": [
        { attribute: "pWkYqcKukAY", description: "Name" }
    ],
    "Inspectorate Unit Activity Tracker": [
        { attribute: "YfoGKu8N6An", description: "Date" },
        { attribute: "Ituuy7n8JGg", description: "Type" },
        { attribute: "ZERTtsbXXc7", description: "Supervisor" },
        { attribute: "XDjgAYmON2o", description: "Address location" },
        { attribute: "IsUOT8aa9xW", description: "Identified issue" },
        { attribute: "G0tGOE5UsOg", description: "Recommendations" },
    ],
    "Key Critical Poverty Issues Tracker": [
        { attribute: "AVnIp8rij7C", description: "Critical development and poverty issues" }
    ],
    "Permits Request Tracker": [
        { attribute: "YfoGKu8N6An", description: "Date" },
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "FuOpGyKgvyG", description: "Purpose" },
        { attribute: "LNAq7fnyatP", description: "Type of Request" },
        { attribute: "pWkYqcKukAY", description: "Year" },
        { attribute: "HfzMa3hSgln", description: "Submitted by" },
        { attribute: "LEV8QecVUev", description: "Received by" },
    ],
    "Street Naming Tracker": [
        { attribute: "Nb0p0tlOqVE", description: "Locality" },
        { attribute: "bWDiirSEBSX", description: "Location" },
        { attribute: "pF64ANEoPYx", description: "Identifiable number" },
        { attribute: "pL0FwhfkQpm", description: "Is the street tarred" },
        { attribute: "pya3uRXtS2R", description: "Is the street named" },
    ],
    "Statutory Member Tracker": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "sGe7MGw4BVN", description: "Phone" },
    ],
    "Logistic Tracker": [
        { attribute: "tcF1c2zJO29", description: "Item category" },
        { attribute: "Ik7fouv4KOA", description: "Select year" },
        { attribute: "zlmMobounnu", description: "Required" },
        { attribute: "kLaD82vCQLh", description: "Actual" },
    ],
    "Vulnerability Tracker": [
        { attribute: "FtQuKEoL20x", description: "Hotline number" }
    ],
    "Legal Case Tracker": [
        { attribute: "K5AYrUoz6EC", description: "Case no" }
    ],
    "LED Related Programs": [
        { attribute: "YfoGKu8N6An", description: "Date" },
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "tORGLTLHCtn", description: "Type" },
        { attribute: "x2GKaz9PPqu", description: "Agenda/Purpose" },
        { attribute: "nFPavqcYnNs", description: "No. of direct beneficiaries male" },
        { attribute: "I8AqLbJESVm", description: "No. of direct beneficiaries female" },
    ],
    "Property Tracker": [
        { attribute: "Nb0p0tlOqVE", description: "Locality" },
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "vIkEALDVio6", description: "Ownership type" },
    ],
    "Marketing Business Tracker": [
        { attribute: "ttyKWvSBAZH", description: "Name of Business" },
        { attribute: "VIU6RY5WpCP", description: "Business Category" },
        { attribute: "Dy3Xf20x913", description: "Scale of operation" },
        { attribute: "bh6EtWj6etP", description: "Quality Standard Requirement" },
        { attribute: "sGe7MGw4BVN", description: "Phone" },
    ],
    "Payment Point Tracker": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "rMNArgwjSNi", description: "Payment Point type" },
        { attribute: "cOxc3578azW", description: "Payment Point Site" },
    ],
    "Audit Issues Tracker": [
        { attribute: "WYgiGtg3fbF", description: "Audit Category" },
        { attribute: "Ik7fouv4KOA", description: "Select Year" },
    ],
    "Annual Progress Report Tracker": [
        { attribute: "IHP9xBgvYu7", description: "Activity Name" }
    ],
    "Revenue Tracker": [
        { attribute: "Ik7fouv4KOA", description: "Select Year" }
    ],
    "Publications Tracker": [
        { attribute: "ozmSnpGukjT", description: "Published Date" },
        { attribute: "VYCQ5lh0HdP", description: "Publication Channel" },
        { attribute: "Iu8c8cj8Dyy", description: "Document Published" },
    ],
    "Sanitation and Waste Tracker": [
        { attribute: "YfoGKu8N6An", description: "Date" }
    ],
    "Social Inclusive Program Tracker": [
        { attribute: "CxW1R33QUV2", description: "Social Inclusive Programme" },
        { attribute: "FVPxJuIxIrM", description: "Primary Funding Source" },
        { attribute: "ZERTtsbXXc7", description: "Supervisor" },
        { attribute: "n7h6V5qo8Td", description: "Number of Target Beneficiaries" },
        { attribute: "mdO1ngv0Qt0", description: "Budget Allocated(Ghana cedis)" },
        { attribute: "gkqU35LKO4t", description: "Start Date" },
    ],
    "Sub Structure Activity Tracker": [
        { attribute: "sI8Kj3pfa6k", description: "Name of Sub structure" },
        { attribute: "hQVox0xawJI", description: "Amount" },
        { attribute: "VjFxjvQk0cO", description: "Activity Description" },
    ],
    "Sub Structure Committee": [
        { attribute: "sI8Kj3pfa6k", description: "Sub Structure Committee" },
        { attribute: "HpWdkwq4K4Q", description: "Sub Structure Committee Category" },
        { attribute: "AlVMRjjWuVo", description: "Established Date" },
    ],
    "Test Fruit Application": [
        { attribute: "JsjIwEt18J0", description: "Fruit | On the scale of 1 - 5" }
    ],
    "Residential Home Centre": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "sGe7MGw4BVN", description: "Phone" },
        { attribute: "BZbNSkBY5w5", description: "Public Hotline" },
    ],
    "User Profile": [
        { attribute: "yPvU4sPN9hh", description: "First Name" },
        { attribute: "PtqWutejid0", description: "Last Name" },
        { attribute: "j3CyzRTfdAk", description: "Gender" },
    ],
    "Documents Hub": [
        { attribute: "wca7mlI2exE", description: "Name" },
        { attribute: "HegQ9f2EvbC", description: "Document Type" },
        { attribute: "wPNjapyO0Jl", description: "Validity Period" },
        { attribute: "iSGLs8Qaq7E", description: "Reference Number" },
    ],
    "Inspectorate Unit Establishment Tracker": [
        { attribute: "AlVMRjjWuVo", description: "Established Date" },
        { attribute: "RXTTz95xaoO", description: "List of Staff" },
    ],
    "Internally Generated Fund Tracker": [
        { attribute: "pWkYqcKukAY", description: "Year" },
        { attribute: "jcFWiKH0Kud", description: "IGF Source" },
        { attribute: "tsmYBpRcYxU", description: "Total Number Issued" },
        { attribute: "xSAif899MME", description: "Amount Budgeted" },
        { attribute: "nlZbT98zSio", description: "Amount Collected" },
    ],
    "One District One Warehouse Tracker": [
        { attribute: "YLKXcF4M13E", description: "Ownership Type" },
        { attribute: "DdrX62P5Fnm", description: "1D1W Component" },
        { attribute: "tTbvdaHiwu2", description: "Status of implementation" },
    ],
    "Social Inclusive Program Beneficiaries Tracker": [
        { attribute: "yPvU4sPN9hh", description: "First Name" },
        { attribute: "PtqWutejid0", description: "Last Name" },
        { attribute: "j3CyzRTfdAk", description: "Gender" },
        { attribute: "UJBblniqPOI", description: "Community" },
    ],
    "Community Profile": [
        { attribute: "wca7mlI2exE", description: "Community" },
        { attribute: "qdDngSjZY9H", description: "Classification" },
    ],
    "Client Service Unit Tracker": [
        { attribute: "KKvCqPE0o4r", description: "Office Available (Yes/No)" },
        { attribute: "AfBfUzcvMVC", description: "Complaints Book available (Yes/No)" },
        { attribute: "YPoOqFSzwjc", description: "Work plan available (Yes/No)" },
        { attribute: "HnIZkFq81E4", description: "Schedule Officer Name" },
        { attribute: "Xwogv0s7lDX", description: "Dedicated Mobile Number" },
    ],
    "ATSheet Training Attendance Sheet Tracker": [
        { attribute: "s0psXh4E3zv", description: "Fullname" },
        { attribute: "deLo7BbZ8Z3", description: "Institution" },
        { attribute: "J7IrEy5foBT", description: "Designation" },
        { attribute: "HgemfhhsXBc", description: "Mobile Number" },
    ],
    "Agricultural Extension and Support Officers": [
        { attribute: "yPvU4sPN9hh", description: "First Name" },
        { attribute: "PtqWutejid0", description: "Last Name" },
        { attribute: "j3CyzRTfdAk", description: "Gender" },
    ],
};

export const getMandatoryFieldByTracker = (tracker) => TRACKER_MANDATORY_FIELDS[tracker] || [];

export const getMissingMandatoryFieldsMessage = (fields, payload) => {
    const messages = [];

    if (!payload || !Array.isArray(payload)) {
        return "Invalid payload data";
    }

    payload.forEach((entity, index) => {
        const missing = [];

        fields.forEach((field) => {
            const match = entity.attributes.find((attr) => attr.attribute === field.attribute);

            if (!match || match.value === null || match.value === undefined || match.value === "") {
                missing.push(field.description || field.attribute);
            }
        });

        if (missing.length > 0) {
            messages.push(`Row ${index + 1}: Missing fields -> ${missing.join(", ")}`);
        }
    });

    if (messages.length === 0) {
        return "All mandatory fields are populated.";
    }

    return messages.join("\n");
};
